import 'magnific-popup/dist/jquery.magnific-popup';
import 'waypoints/lib/jquery.waypoints';
import 'jquery.counterup/jquery.counterup.min';
import 'slick-carousel';
import 'isotope-layout/dist/isotope.pkgd';
import 'select2/dist/js/select2';
import 'vanilla-fitvids/jquery.fitvids';

export default {
  init() {
    // JavaScript to be fired on all pages
    $('.fluid-video').fitVids();

    $('.image-prev').on( 'click', function() {
      $(this).removeClass('block');
      $(this).addClass('hidden');
      $(this).next().removeClass('hidden').addClass('block').children().trigger('play');
    });

    $('.tab_content').hide(); //Hide all content
    $('ul.tabs li:first').addClass('active').show(); //Activate first tab
    $('.tab_content:first').show(); //Show first tab content

    var $grid = $('.isotope-list').isotope({
      itemSelector: '.isotope-item',
      layoutMode: 'fitRows',
    });

    // store filter for each group
    var filters = {};

    // bind filter button click
    $('.button-group').on( 'click', 'button', function() {
      var $this = $(this);
      // get group key
      var $buttonGroup = $this.parents('.button-group');
      var filterGroup = $buttonGroup.attr('data-filter-group');
      // set filter for group
      filters[ filterGroup ] = $this.attr('data-filter');
      // combine filters
      var filterValue = concatValues( filters );
      $grid.isotope({ filter: filterValue });
    });

    // flatten object by concatting values
    function concatValues( obj ) {
      var value = '';
      for ( var prop in obj ) {
        value += obj[ prop ];
      }
      return value;
    }

    // change is-checked class on buttons
    $('.button-group').each( function( i, buttonGroup ) {
      var $buttonGroup = $( buttonGroup );
      $buttonGroup.on( 'click', 'button', function() {
        $buttonGroup.find('.is-checked').removeClass('is-checked');
        $( this ).addClass('is-checked');
      });
    });

    $('.filters-select').on( 'change', function() {
      var filterValue = this.value;
      $grid.isotope({ filter: filterValue });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('select').select2();

    $('.counter-up').counterUp();

    $('.cta-modal').magnificPopup({
      type:'inline',
      midClick: true,
    });

    $('ul.tabs li').click(function() {

      $('ul.tabs li').removeClass('active'); //Remove any 'active' class
      $(this).addClass('active'); //Add 'active' class to selected tab
      $('.tab_content').hide(); //Hide all tab content

      var activeTab = $(this).find('a').attr('href');
      $(activeTab).fadeIn(); //Fade in the active ID content
      return false;
    });

    var $carousel = $('.gallery-list');

    $carousel
        .slick({
          slidesToShow: 4,
          centerMode: false,
          swipeToSlide: true,
          infinite: false,
          prevArrow:'<button type="button" class="slick-prev pull-right"><i class="text-night_rider hover:text-night_rider text-5xl icons-s2b icon-s2b-arrow_carrot-left hover:no-underline"></i></button>',
          nextArrow:'<button type="button" class="slick-next pull-right"><i class="text-night_rider hover:text-night_rider text-5xl icons-s2b icon-s2b-arrow_carrot-right hover:no-underline"></i></button>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                centerMode: false,
                swipeToSlide: true,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                centerMode: false,
                swipeToSlide: true,
              },
            },
          ],
        })
        .magnificPopup({
            type: 'image',
            delegate: 'a:not(.slick-cloned)',
            gallery: {
                enabled: true,
            },
            callbacks: {
                open: function() {
                    var current = $carousel.slick('slickCurrentSlide');
                    $carousel.magnificPopup('goTo', current);
                },
                beforeClose: function() {
                    $carousel.slick('slickGoTo', parseInt(this.index));
                },
            },
        });

    $('.person-list-carousel').slick({
      slidesToShow: 5,
      centerMode: true,
      swipeToSlide: true,
      prevArrow:'<button type="button" class="slick-prev pull-right"><i class="text-night_rider hover:text-night_rider text-5xl icons-s2b icon-s2b-arrow_carrot-left hover:no-underline"></i></button>',
      nextArrow:'<button type="button" class="slick-next pull-right"><i class="text-night_rider hover:text-night_rider text-5xl icons-s2b icon-s2b-arrow_carrot-right hover:no-underline"></i></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            centerMode: true,
            swipeToSlide: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            swipeToSlide: true,
          },
        },
      ],
    });

    $('.startups-list-carousel').slick({
      slidesToShow: 4,
      centerMode: false,
      swipeToSlide: true,
      infinite: false,
      prevArrow:'<button type="button" class="slick-prev pull-right"><i class="text-night_rider hover:text-night_rider text-5xl icons-s2b icon-s2b-arrow_carrot-left hover:no-underline"></i></button>',
      nextArrow:'<button type="button" class="slick-next pull-right"><i class="text-night_rider hover:text-night_rider text-5xl icons-s2b icon-s2b-arrow_carrot-right hover:no-underline"></i></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            centerMode: false,
            swipeToSlide: true,
            infinite: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            swipeToSlide: true,
            infinite: false,
          },
        },
      ],
    });

    $('.posts-list-carousel').slick({
      rows: 0,
      slidesToShow: 3,
      slidesToScroll: 3,
      centerMode: false,
      infinite: false,
      swipeToSlide: true,
      prevArrow:'<button type="button" class="slick-prev pull-right"><i class="text-night_rider hover:text-night_rider text-5xl icons-s2b icon-s2b-arrow_carrot-left hover:no-underline"></i></button>',
      nextArrow:'<button type="button" class="slick-next pull-right"><i class="text-night_rider hover:text-night_rider text-5xl icons-s2b icon-s2b-arrow_carrot-right hover:no-underline"></i></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            swipeToSlide: true,
            infinite: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            swipeToSlide: true,
            infinite: false,
          },
        },
      ],
    });

    $('.experience-list-carousel').slick({
      rows: 0,
      slidesToShow: 3,
      centerMode: false,
      swipeToSlide: true,
      infinite: false,
      prevArrow:'<button type="button" class="slick-prev pull-right"><i class="text-night_rider hover:text-night_rider text-5xl icons-s2b icon-s2b-arrow_carrot-left hover:no-underline"></i></button>',
      nextArrow:'<button type="button" class="slick-next pull-right"><i class="text-night_rider hover:text-night_rider text-5xl icons-s2b icon-s2b-arrow_carrot-right hover:no-underline"></i></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            swipeToSlide: true,
            infinite: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            swipeToSlide: true,
            infinite: false,
          },
        },
      ],
    });

    $('.partners-list-carousel').slick({
      rows: 0,
      slidesToShow: 8,
      centerMode: false,
      swipeToSlide: true,
      infinite: false,
      prevArrow:'<button type="button" class="slick-prev pull-right"><i class="text-night_rider hover:text-night_rider text-5xl icons-s2b icon-s2b-arrow_carrot-left hover:no-underline"></i></button>',
      nextArrow:'<button type="button" class="slick-next pull-right"><i class="text-night_rider hover:text-night_rider text-5xl icons-s2b icon-s2b-arrow_carrot-right hover:no-underline"></i></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
            centerMode: false,
            swipeToSlide: true,
            infinite: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            centerMode: false,
            swipeToSlide: true,
            infinite: false,
          },
        },
      ],
    });

    $('.b-info-box-list-carousel').slick({
      slidesToShow: 5,
      centerMode: false,
      swipeToSlide: true,
      infinite: false,
      prevArrow:'<button type="button" class="slick-prev pull-right"><i class="text-night_rider hover:text-night_rider text-5xl icons-s2b icon-s2b-arrow_carrot-left hover:no-underline"></i></button>',
      nextArrow:'<button type="button" class="slick-next pull-right"><i class="text-night_rider hover:text-night_rider text-5xl icons-s2b icon-s2b-arrow_carrot-right hover:no-underline"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            swipeToSlide: true,
            infinite: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            swipeToSlide: true,
            infinite: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            swipeToSlide: true,
            infinite: false,
          },
        },
      ],
    });

    $('.b-slide-list').slick({
      slidesToShow: 1,
      centerMode: false,
      swipeToSlide: true,
      infinite: false,
      arrows: false,
      dots: true,
    });

    /*
    var lastId,
    topMenu = $('.nav-navigation ul.max-mega-menu'),
    topMenuHeight = topMenu.outerHeight()+15,
    menuItems = topMenu.find('a'),
    scrollItems = menuItems.map(function(){
      var item = $($(this).attr('href'));
      if (item.length) { return item; }
    });

    menuItems.click(function(e){
    var href = $(this).attr('href'),
      offsetTop = href === '#' ? 0 : $(href).offset().top-topMenuHeight+1;
    $('html, body').stop().animate({
      scrollTop: offsetTop,
    }, 800);
    e.preventDefault();
    });

    $(window).scroll(function(){
    var fromTop = $(this).scrollTop()+topMenuHeight;

    var cur = scrollItems.map(function(){
    if ($(this).offset().top < fromTop)
      return this;
    });

    cur = cur[cur.length-1];
    var id = cur && cur.length ? cur[0].id : '';

    if (lastId !== id) {
      lastId = id;
      menuItems
        .parent().removeClass('mega-current-menu-item')
        .end().filter('[href="#'+id+'"]').parent().addClass('mega-current-menu-item');
    }
    });

    $('.nav-navigation ul.max-mega-menu a').on('click', function(event) {
      if (this.hash !== '') {
        event.preventDefault();
        var hash = this.hash;
        $('html, body').animate({
          scrollTop: $(hash).offset().top,
        }, 800, function(){
          window.location.hash = hash;
        });
      }
    });
    */

    var stickyTop = $('.header-wrapper').offset().top;

    $(window).scroll(function() {
      var windowTop = $(window).scrollTop();

      if (stickyTop < windowTop) {
        $('.header-wrapper').addClass('sticked');
        $('.header-wrapper').removeClass('relative');
      } else {
        $('.header-wrapper').removeClass('sticked');
        $('.header-wrapper').addClass('relative');
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js